<app-image-box-link
    (loaded)="emit_onLoaded()"
    (onClickEmit)="emit_onClick($event)"
    [matTooltip]="tooltip$$()"
    [matTooltipPosition]="tooltipPosition$$()"
    [noClick]="noClick$$()"
    [guid]="guid$$()"
    [url]="url$$()"
    [version]="version$$()"
    [border]="border$$()"
>
    <ng-content />
</app-image-box-link>
